<div fxLayout="column" fxLayoutGap="10px" style="padding-bottom: 5px;font-family: Roboto, Helvetica Neue, sans-serif;">
  <mat-form-field>
    <mat-select placeholder="Filtrer par direction / composante..."
                [formControl]="dircmpControl"
                [matTooltip]="'Filtrer sur une direction / composante...'"
                (selectionChange)="onSelected($event)">
      <ng-container>
        <mat-option *ngFor="let dircmp of dircmps" [value]="dircmp">
          <span [matTooltip]="toolTip(dircmp)" [attr.data-cy]="'option-filter-dir-cmp-deposits-' + dircmp.id">
            {{dircmp?.acronym || dircmp?.entite_archivage_obj?.entite_obj?.name}}
          </span>
        </mat-option>
      </ng-container>
    </mat-select>
  </mat-form-field>
  <div>
    <button color="accent" class="mat-button mat-small" mat-raised-button (click)="onValidate($event)" matTooltip="Filtrer" data-cy="btn-dir-cmp-deposits-filtering">Filtrer</button>&nbsp;
  </div>
</div>
